import {
  configureStore,
  getDefaultMiddleware,
  combineReducers,
} from "@reduxjs/toolkit"
import logger from "redux-logger"
import localForage from "localforage"
import { persistStore, persistReducer } from "redux-persist"
import cartReducer, { cartTransforms } from "./cartSlice"

const prodMiddleware = []
const devMiddleware = [logger]

let middleware = [...getDefaultMiddleware(), ...prodMiddleware]

if (process.env.NODE_ENV !== "production") {
  middleware = [...middleware, ...devMiddleware]
}

const rootReducer = combineReducers({
  cart: cartReducer,
})

const persistConfig = {
  key: "root",
  storage: localForage,
  whitelist: ["cart"],
  transforms: [cartTransforms.removeDeletedProductsFromCart],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export function createReduxStore({ persisted = true }) {
  const store = configureStore({
    reducer: persisted ? persistedReducer : rootReducer,
    middleware,
  })

  const persistor = persisted ? persistStore(store) : null

  return [store, persistor]
}
